import { Subject } from "rxjs";
import { filter, first, map } from "rxjs/operators";
import { log2 } from "./log2";
import store from "../store/index";
import EVENT_BUS, { publishMessage, SystemMessageTypes } from "./systemPubSub";
import _ from "lodash";
import { getPersistenceData } from "./persistenceStorage";

const log = log2("parentWindowConnection");
const messages = new Subject();
var id = 0;
const nextId = () => {
    id += 1;
    return id * -1;
};

export const parentWindowMessageStream = messages.asObservable();

window.onmessage = function (e) {
    log("onmessage from parent", e.data);
    if (e.data.command === "ping") {
        window.parent.postMessage({ command: "pong" }, "*");
    } else if (e.data.command === "close-chat") {
        EVENT_BUS.publish(EVENT_BUS.MessageTypes.CLOSE_CHAT, {});
    } else {
        messages.next(e.data);
    }
};

export const sendMinimizeAction = () => {
    log("sendMinimizeAction");
    sendCommandToParentWindow("minimize", {});
};
export const sendMaximizeAction = () => {
    log("sendMaximizeAction");
    sendMinimizeAction();
    sendCommandToParentWindow("maximize", {});
};

export const sendOpenBubbleRequest = () => {
    log("sendOpenBubbleRequest");
    sendCommandToParentWindow("open", {});
};
export const requestHostUrl = () => {
    const result = parentWindowMessageStream
        .pipe(
            filter((q) => q.command === "current-url"),
            first(),
            map((x) => x.payload.url)
        )
        .toPromise();

    sendCommandToParentWindow("report-url", {});
    return result;
};
export const requestHostInfo = () => {
    const result = parentWindowMessageStream
        .pipe(
            filter((q) => q.command === "current-info"),
            first(),
            map((x) => x.payload)
        )
        .toPromise();

    sendCommandToParentWindow("report-info", {});
    return result;
};
export const requestKMKSellerId = () => {
    sendCommandToParentWindow("report-kmk-seller-id", {});
};
export const onHostPageClosing = () => {
    return parentWindowMessageStream
        .pipe(
            filter((q) => q.command === "host-page-closing"),
            first()
        )
        .toPromise();
};
export const onMobileVersionDetected = () => {
    return parentWindowMessageStream
        .pipe(
            filter((q) => q.command === "mobile-detected"),
            map((x) => x.payload),
            first()
        )
        .toPromise();
};

export const chatBaloonIsOpened = (cb) => {
    return parentWindowMessageStream.pipe(filter((q) => q.command === "iframe-open")).subscribe({
        next() {
            cb();
        },
    });
};

var connectedMessageCount = 0;
// Panel onizlemesinde host sayfa panelin kendisidir; komutlar panelin destek balonuna gitmesin
const IS_PANEL_PREVIEW = window.self !== window.top && window.location.search.indexOf("preview") !== -1;
export const sendCommandToParentWindow = (command, payload, id) => {
    if (IS_PANEL_PREVIEW) return;
    // log.debug("sendCommandToParentWindow", command);
    id = id ? id : nextId();
    if (command === "connected") {
        payload = {
            nonce: connectedMessageCount++,
        };
    }
    if (_.get(window, "ReactNativeWebView.postMessage")) {
        window.ReactNativeWebView.postMessage(
            JSON.stringify({
                id,
                command,
                payload,
            })
        );
    }
    window.top.postMessage(
        {
            id,
            command,
            payload,
        },
        "*"
    );
};

setTimeout(() => {
    requestHostUrl().then((url) => {
        log("requestHostUrl", url);
    });
}, 10000);

requestHostInfo().then((info) => {
    log("requestHostInfo", info);
});

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-user-data"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("setPreDefinedUserData", payload);
        store.dispatch("chat/setPreDefinedUserData", payload);
        publishMessage(SystemMessageTypes.SYNC_PRE_DEFINED_USER_DATA, payload);
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-department"),
        map((x) => x.payload)
    )
    .subscribe((department) => {
        log("change department", department);
        store.dispatch("chat/changePreSelectedDepartment", department);
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "auto-login"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("auto-login from parent", payload);
        const { initialMessage, loginData, sendIfConnected } = payload;
        if (!_.get(loginData, "akinonUser")) {
            store.dispatch("chat/setPreDefinedUserData", loginData);
        }

        publishMessage("AUTO_LOGIN", { initialMessage, loginData, sendIfConnected: !!sendIfConnected });
    });

// Host sayfasindan ziyaretci adina mesaj (supsis.sendMessage). Bos metin yok sayilir, 4000 karakterde kesilir.
// Gonderim App.vue'de: sohbet bagliysa normal ziyaretci mesaji, degilse autoLogin (ilk mesajla giris).
parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "send-message"),
        map((x) => x.payload || {})
    )
    .subscribe((payload) => {
        const text = String(payload.text == null ? "" : payload.text).trim().slice(0, 4000);
        if (!text) return;
        log("send-message from parent", { length: text.length });
        publishMessage(SystemMessageTypes.HOST_SEND_MESSAGE, { text });
    });

parentWindowMessageStream.subscribe(({ command, payload }) => {
    if (command === "set-chatbot-start-block-id") {
        store.dispatch("chat/setPreferredChatbotStartBlockId", payload.blockId);
    }
});

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-contact-property"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("setContactPropertyData", payload);
        store.dispatch("chat/setContactPropertyData", payload);
        publishMessage("contact_property_set", payload);
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-trigger-data"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("setTriggerData", payload);
        // Dairesel import olmasin diye calisma aninda cozuluyor.
        require("./trigger").Trigger.setData(payload);
    });

parentWindowMessageStream
    .pipe(filter((q) => q.command === "disable-triggers"))
    .subscribe(() => {
        log("disableTriggers");
        require("./trigger").Trigger.disable();
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "trigger-start-chat"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        if (require("./trigger").Trigger.isDisabled()) return;
        log("trigger-start-chat", payload);
        if (payload.skipLoginForm) store.dispatch("chat/setSkipLoginFormFromTrigger", true);
        if (payload.initialMessage) {
            publishMessage("AUTO_LOGIN", { initialMessage: payload.initialMessage, loginData: {} });
        }
    });

// "Sohbeti dogrudan ac" tetikleyicisi: pencere acilirken karsilama balonu gosterilir.
parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "trigger-open-chat"),
        map((x) => x.payload || {})
    )
    .subscribe((payload) => {
        if (require("./trigger").Trigger.isDisabled()) return;
        log("trigger-open-chat", payload);
        publishMessage(SystemMessageTypes.TRIGGER_WELCOME, payload);
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "set-vip-customer"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("setVipCustomer", payload);
        publishMessage("set_vip_customer", payload);
    });

parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "clear-cache"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    });

// Web Voice Agent için visitor ID'yi gönder
parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "get-visitor-id"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        log("get-visitor-id isteği alındı");
        // Store'dan visitor ID'yi al
        const visitorId = getPersistenceData("visitorId");
        log("Visitor ID gönderiliyor:", visitorId);

        // Tüm iframelere mesaj gönder (web-voice-agent bileşenini bulabilmek için)
        window.top.postMessage(
            {
                command: "set-visitor-id",
                payload: {
                    visitorId: visitorId
                }
            },
            "*"
        );
    });

// Panel Ana Sayfa editoru: kaydetmeden onizleme taslagi (yalniz preview modunda islenir)
parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "homeScreenDraft"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        store.dispatch("shell/setDraft", payload);
    });

// Panel tema/kurulum ekranlari: kaydedilmemis ayarlarin onizlemesi (yalniz preview modunda islenir)
parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "settingsDraft"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        store.dispatch("setting/setPreviewDraft", payload);
    });

// Host sayfasindan sekme/makale/arama yonlendirmesi: supsis.open/openArticle/search
parentWindowMessageStream
    .pipe(
        filter((q) => q.command === "shell-navigate"),
        map((x) => x.payload)
    )
    .subscribe((payload) => {
        store.dispatch("shell/navigate", payload || {});
    });

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(() => {
    if (_.get(window, "ReactNativeWebView.postMessage")) {
        window.ReactNativeWebView.postMessage("webview-loaded");
    }
});



// WEBPACK FOOTER //
// ./src/utils/parentWindowConnection.js